import './Privacy.scss'
import Navbar from '../landing/components/Navbar'
import { useNavigate } from 'react-router-dom'
import Privacyimg from '../../assets/images/amico5.png'
import wave from '../../assets/images/ph_waves-thin.png'
import star from '../../assets/images/Vector 166.png'
import { Icon } from '@iconify/react'
import FaqsTACData from '../../assets/data/FaqsTACData'
import { useState } from 'react'
import Logo from '../../assets/images/logo-white.png'

const Privacy = () => {
  const navigate = useNavigate()
  const [selectedQuestion, setSelectedQuestion] = useState(0)

  return (
    <div className='privacy-page'>
      <Navbar usage='privacy' />

      <div className='hero'>
        <div className='hero-wrapper flex flex-wrap justify-between'>
          <div className='left'>
            <div className='left-wrap'>
              <h1>
                QC EXPRESS <br /> privacy policy
              </h1>
              <p>
                Your privacy is our priority – we are committed to safeguarding
                your personal and business information. Our privacy policy
                ensures that all data is handled securely and transparently,
                giving you peace of mind with every transaction.
              </p>
              <img src={wave} alt='wave' className='wave' />
            </div>
          </div>
          <div className='right'>
            <img src={Privacyimg} alt='programmer' />
          </div>
        </div>
      </div>

      <div className='privacy-container'>
        <div className='breadcrumb'>
          <span>HOME</span>/<span className='active'> PRIVACY POLICY</span>
        </div>

        <img src={star} alt='' className='star' />

        <div className='privacy-box'>
          <h2>Our Commitment to you.</h2>
          <p>
            QC Express respects your privacy and is committed to ensuring the
            security of personal information collected from you through our
            website. This privacy policy outlines our processes and policies in
            the way we collect and use information, and by using the services on
            our website ('Services') you agree to be bound by this policy. The
            use of the terms 'we/us/our' refer to QC Express.
          </p>

          <h2>Information Collected By Us</h2>
          <p>
            When you access or register on our website to use our Services, you
            will have the option to provide us with personal information, such
            as your email address, so that we may keep you informed. We use this
            information only in response to your requests in providing you our
            Services. <br />
            When you visit or register on our website, we may place one or more
            cookies (a text file that is stored by your browser to recognize you
            and store your preferences) on your computer. This primarily assists
            us to improve our service offering by using previously stored data
            to quickly provide you more user friendly services. You will always
            be able to turn off this service by adjusting the settings on your
            browser to refuse cookies, but please note that some of our services
            may not work if you do so. We also reserve the right to log
            information from your computer including the existence of cookies,
            your IP address and information about your browser program in order
            to allow us to diagnose problems, administer and track your usage of
            our services.
          </p>

          <h2>How We Use Your Information.</h2>
          <p>
            We use data and information we collect to provide the Services and
            to communicate with you. We do not and will not rent or sell
            personal information and will only share your information in the
            following circumstances: In satisfaction of any legal requirement or
            order, or protection of our rights and interests or prevention of
            fraud; Where you have granted consent of instructed us to share your
            information; To our service providers or associated companies who
            provide services to us; Where our business is merged or sold to
            other entities and the transfer of such information forms part of
            the assets;
          </p>

          <h2>Information Collected By Us.</h2>
          <p>
            We use third parties to provide advertisements and promotions on our
            website and these third parties may use cookies or other means to
            help measure the effectiveness of their advertisements. Our website
            may also include links to other unrelated websites and/or contact
            forms to other unrelated parties which may collect personal
            information. Our privacy policy does not extend to these third
            parties or other websites and we recommend that users refer directly
            to these parties regarding their privacy policies before supplying
            personal details to these companies.
          </p>

          <h2>Safety and Security.</h2>
          <p>
            The personal information of our users is processed and stored in our
            databases. We undertake and have taken reasonable steps to ensure
            the security and protection of the information under our control,
            including setting up protocols and processes to prevent unauthorized
            access or disclosure of this information. However, whilst we have
            taken every reasonable step to ensure the security of your
            information, we are unable to fully guarantee the protection of such
            information from misuse, accidental disclosure or unauthorized acts
            by others.
          </p>

          <h2>Changes to Privacy Policy.</h2>
          <p>
            We reserve the right to change this privacy policy at any time
            without prior notice. Every change effected will be reflected on our
            website and take effect immediately such changes are posted. Where
            such changes materially affect the use or disclosure of your
            personal information, we will make reasonable efforts to notify you
            of these changes.
          </p>
        </div>
      </div>

      <div className='faqs'>
        <div className='wrapper'>
          <div className='top'>
            <h1 className='gradient-text'>frequently asked questions(FAQs)</h1>
            <p>
              Find answers to common inquiries in our Frequently Asked Questions
              (FAQ) section.
            </p>
          </div>
          <div className='faq-list'>
            {FaqsTACData.map((data, index) => (
              <div className='faq' key={index}>
                <div
                  className='question flex justify-between'
                  onClick={() => setSelectedQuestion(index)}
                >
                  <h3>{data.question}</h3>
                  <div>
                    {selectedQuestion === index ? (
                      <Icon icon='akar-icons:chevron-up' />
                    ) : (
                      <Icon icon='akar-icons:chevron-down' />
                    )}
                  </div>
                </div>
                {selectedQuestion === index && (
                  <div className='answer'>
                    <p>{data.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className='footer'>
        <div className='wrapper'>
          <div className='flex justify-between flex-wrap'>
            <div className='card logo'>
              <img src={Logo} alt='' />
              <p>
                Your trusted partner in getting goods where they need to be,
                fast and safe.
              </p>
            </div>

            <div className='card'>
              <h3>Contact Us</h3>
              <div className='flex'>
                <div>
                  <div className='icon'>
                    <Icon icon='mdi:location' />
                  </div>
                </div>
                <div className='text'>
                  <p>Location:</p>
                  <p>
                    14A Olatunji Close, Off Continental Way, Ikosi GRA IV,
                    Magodo, Lagos-Nigeria.
                  </p>
                </div>
              </div>
              <div className='flex'>
                <div>
                  <div className='icon'>
                    <Icon icon='ic:baseline-phone' />
                  </div>
                </div>
                <div className='text'>
                  <p>Phone Number:</p>
                  <p>
                    +234 912 049 9852–7, +234 802 0549 655, +234 802 290 2446
                  </p>
                </div>
              </div>
              <div className='flex'>
                <div>
                  <div className='icon'>
                    <Icon icon='bxs:envelope' />
                  </div>
                </div>
                <div className='text'>
                  <p>Email:</p>
                  <p>customercare@quartzclassic.com</p>
                </div>
              </div>
            </div>
            <div className='card'>
              <h3 className='newsletter-h3'>SUBSCRIBE TO OUR NEWSLETTER</h3>
              <input type='text' placeholder='Enter your email' />
              <br />
              <button onClick={() => navigate('/')}>Subscribe</button>
              <div className='socials'>
                <a
                  href='https://www.instagram.com/qc_express?igsh=NjhyYWZtNm1lN3Rk'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <Icon icon='akar-icons:instagram-fill' />
                </a>
                <Icon icon='akar-icons:facebook-fill' />
                <a
                  href='https://x.com/qc_express'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <Icon icon='akar-icons:twitter-fill' />
                </a>
              </div>
            </div>
          </div>
          <hr />
          <p className='footer-p'>&copy; QC Express. All rights reserved.</p>
        </div>
      </div>
    </div>
  )
}

export default Privacy
